import { render, staticRenderFns } from "./NotificationDispatchDetails.vue?vue&type=template&id=e17a9d64&"
import script from "./NotificationDispatchDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationDispatchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports